import { Loading } from 'element-ui';

let loading = null // 定义loading变量
let timeout = null
// 开始 加载loading
const startLoading = (windowWidth,text = '数据加载中...') => {
    loading = Loading.service({
        lock: true,
        text: text,
        background: 'rgba(0, 0, 0, 0.3)',
        customClass: 'common-loading'
    })
}
// 结束 取消loading加载
const endLoading = () => {
    loading.close()
    timeout&&clearTimeout(timeout)
}

// showFullScreenLoading() 与 tryHideFullScreenLoading() 目的是合并同一页面多个请求触发loading

let needLoadingRequestCount = 0 // 声明一个变量

const showFullScreenLoading = (windowWidth,text) => {
    if (needLoadingRequestCount === 0) { // 当等于0时证明第一次请求 这时开启loading
        startLoading(windowWidth,text)
    }
    needLoadingRequestCount++ // 全局变量值++
}

const tryHideFullScreenLoading = () => {
    if (needLoadingRequestCount <= 0) return // 小于等于0 证明没有开启loading 此时return
    needLoadingRequestCount-- // 正常响应后 全局变量 --
    if (needLoadingRequestCount === 0) { // 等于0 时证明全部加载完毕 此时结束loading 加载
        timeout = setTimeout(endLoading(),200)
    }
}
const loadingObj = {
    showFullScreenLoading,
    tryHideFullScreenLoading
}

export default loadingObj
